import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/entrance',
            name: 'entrance',
            component: () => import('../components/page/Entrance.vue'),
            meta: { title: '中控平台' }
        },
        // {
        //     path: '/',
        //     component: () => import('../components/common/Home.vue'),
        //     meta: { title: '自述文件' },
        //     children: [
                
        //     ]
        // },
        // 数据看板相关
        {
            path: '/',
            component: () => import('../components/page/DataPanel/Home.vue'),
            meta: { title: '数据看板自述文件' },
            children: [
                {
                    path: '/company_targets_progress',
                    name: 'company_targets_progress',
                    component: () => import('../components/page/DataPanel/CompanyTargetsProgress.vue'),
                    meta: { title: '业绩看板' }
                },
                {
                    path: '/data_panel_for_com',
                    name: 'data_panel_for_com',
                    component: () => import('../components/page/DataPanel/CompanyDisData.vue'),
                    meta: { title: '销售看板' }
                },
                {
                    path: '/data_panel_for_user',
                    name: 'data_panel_for_user',
                    component: () => import('../components/page/DataPanel/UserDisData.vue'),
                    meta: { title: '员工看板' }
                },
                {
                    path: '/data_panel_for_goods',
                    name: 'data_panel_for_goods',
                    component: () => import('../components/page/DataPanel/GoodsDisData.vue'),
                    meta: { title: '商品看板' }
                },
                {
                    path: '/data_panel_for_purchaser',
                    name: 'data_panel_for_purchaser',
                    component: () => import('../components/page/DataPanel/PurchaserDisData.vue'),
                    meta: { title: '供应商看板' }
                },
                {
                    path: '/data_panel_for_dist',
                    name: 'data_panel_for_dist',
                    component: () => import('../components/page/DataPanel/DistDisData.vue'),
                    meta: { title: '客户看板' }
                },
                {
                    path: '/data_panel_for_par',
                    name: 'data_panel_for_par',
                    component: () => import('../components/page/DataPanel/ParDisData.vue'),
                    meta: { title: '合作商看板' }
                },
                {
                    path: '/data_panel_for_funds',
                    name: 'data_panel_for_funds',
                    component: () => import('../components/page/DataPanel/Funds.vue'),
                    meta: { title: '资金看板' }
                },
                {
                    path: '/data_panel_for_captail',
                    name: 'data_panel_for_captail',
                    component: () => import('../components/page/DataPanel/CaptailData.vue'),
                    meta: { title: '经营数据看板' }
                },
                {
                    path: '/business_analysis',
                    name: 'business_analysis',
                    component: () => import('../components/page/DataPanel/BusinessAnalysis.vue'),
                    meta: { title: '商机分析' }
                },
                {
                    path: '/data_panel_for_project',
                    name: 'data_panel_for_project',
                    component: () => import('../components/page/DataPanel/ProjectProgress.vue'),
                    meta: { title: '项目看板' }
                },
            ]
        },
        // 周报相关
        {
            path: '/weekly',
            name: 'weekly',
            component: () => import('../components/page/Weekly/Index.vue'),
            meta: { title: '周报统计' }
        },
        {
            path: '/weekly_for_phone',
            name: 'weekly_for_phone',
            component: () => import('../components/page/Weekly/Phone.vue'),
            meta: { title: '周报统计' }
        },
        {
            path: '*',
            redirect: '/login'
        }
    ]
});
